export function OAuthDivider() {
  return (
    <div className="flex items-center gap-3" data-testid="oauth-divider">
      <div className="h-px flex-1 bg-glass-stroke-light" />
      <span className="text-[13px] text-muted">or</span>
      <div className="h-px flex-1 bg-glass-stroke-light" />
    </div>
  );
}
